<template>
  <div>

    <template>
      <arksnackbar v-model="status"></arksnackbar>
      <loader v-model=status.loading></loader>
    </template>

    <confirm ref="confirm"></confirm>
    <span id="demo22"></span>

    <v-select hide-details v-model="item" :items="items" item-text="ad" item-value="id" :label="$t('Report-Template')"
      return-object>
      <v-menu slot="append-outer" style="top: -12px" offset-y>
        <v-btn :style=GetMenuDisable color="info" small slot="activator"> {{ $t('Design-Menu') }} </v-btn>
        <v-card>
          <v-btn small flat color="primary" @click="DesignShow()">Dizayn Yap</v-btn>
          <v-btn small flat color="primary" @click="dialogEkle=true">{{ $t('Add-Design') }}</v-btn>
          <v-btn small flat color="warning" @click="DizaynDelete()">{{ $t('Delete-Design') }}</v-btn>
        </v-card>
      </v-menu>
    </v-select>

    <customdialog v-model="dialogEkle" maxWidth="400px" cardtextstyle="height: 160px;" :title="$t('Add-Design')">
      <slot name="dialogmain">
        <v-text-field hide-details :label="$t('Design-Name')" v-model="dizaynAdi"></v-text-field>
      </slot>
      <template slot="btn">
        <v-btn color="primary" flat @click="DizaynEkle()">{{$t("save_button")}}</v-btn>
      </template>
    </customdialog>

    <customdialog v-model="dizayndialog" maxWidth="850px" cardtextstyle="height: 600px;" title="Dizayn Yap">
      <slot name="dialogmain">

        <v-layout>
          <v-list two-line>
            <template v-for="(item, index) in dizaynData">

              <v-list-tile :key="item.value" avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.value"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.text"></v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>

                  <v-btn @click="ItemAktar(dizaynData,dizaynData2,item)" icon ripple>
                    <v-icon color="grey lighten-1">arrow_forward</v-icon>
                  </v-btn>

                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>

          <v-list two-line>
            <template v-for="(item, index) in dizaynData2">

              <v-list-tile :key="item.value" avatar>

                <v-list-tile-avatar>
                  <v-btn @click="ItemAktar(dizaynData2,dizaynData,item)" icon ripple>
                    <v-icon color="grey lighten-1">arrow_back</v-icon>
                  </v-btn>

                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-text-field hide-details :label="item.value+' :'" v-model="item.text"></v-text-field>
                </v-list-tile-content>
                <v-list-tile-action>

                  <v-btn @click="YukariTasi(dizaynData2,item)" icon ripple>
                    <v-icon color="grey lighten-1">arrow_drop_up</v-icon>
                  </v-btn>

                  <v-btn @click="AsagiTasi(dizaynData2,item)" icon ripple>
                    <v-icon color="grey lighten-1">arrow_drop_down</v-icon>
                  </v-btn>

                </v-list-tile-action>

              </v-list-tile>
            </template>
          </v-list>
        </v-layout>

      </slot>
      <template slot="btn">
        <v-btn color="primary" flat @click="DizaynKaydet()">{{$t("save_button")}}</v-btn>
      </template>
    </customdialog>

  </div>
</template>

<script>
  import auth from "../../../../api/auth.js"
  import tool from "../tools";
  import customdialog from "@/components/app/coper/comp/customdialog.vue";
  import confirm from "@/components/app/coper/comp/confirm.vue";
  import loader from "@/components/app/coper/comp/loader.vue";
  import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";

  export default {
    props: ["value", "dizayngrupadi", "objectname", "menudisable"],
    components: {
      customdialog,
      confirm,
      loader,
      arksnackbar,

    },

    computed: {
      DizaynId: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit("input", newValue);
        }
      },

      item: {
        get: function () {
          return this.fitem;
        },
        set: function (newValue) {
          if (newValue != undefined && newValue.id != undefined && newValue.id > 0) {
            //this.DizaynId = newValue.id.valueOf();
            this.DizaynId = newValue;

          }
          this.fitem = newValue;
        }
      },

      GetDizaynGrupAdi: {
        get: function () {
          var r = this.dizayngrupadi;
          return r;
        }
      },

      GetMenuDisable: {
        get: function () {

          if (this.menudisable == undefined) {
            return "";
          } else {
            return "display:none;";
          }

        }
      },

      GetObjectName: {
        get: function () {
          var r = this.objectname;
          return r;
        }
      }

    },

    data() {
      return {
        items: [],
        fitem: {},
        dialogEkle: false,
        dialogEdit: false,

        dizayndialog: false,

        dizaynAdi: "",
        dizaynParametre: "",
        resolve: null,
        reject: null,
        prm: {},
        Guid: "",
        saveurl: "",
        ilkYukleme: true,

        dizaynData: [],
        dizaynData2: [],
        status: tool.NewSatatus(),

      };
    },
    created: function () {
      this.sablonGetir();

    },

    mounted() {

    },
    methods: {

      Excel(val) {

        var prm = {
          prm: val,
          objectName: this.GetObjectName,
          id: this.DizaynId.id
        }

        this.status.loading = true;

        tool.api_post_FileDownload(this, "RaporSablon/GetReportExcel", prm).then(
          response => {

            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "GetReport.xlsx";
            link.click();
            this.status.loading = false;
          },
          response => {
            this.status = tool.responseToStatus(response);
          }
        );
      },

      Report(val) {
        var prm = {
          prm: val,
          objectName: this.GetObjectName,
          id: this.DizaynId.id
        }

        this.kayitgetir(prm);

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },

      kayitgetir(prm) {
        this.status.loading = true;
        tool.api_post(this, "RaporSablon/GetReport", prm).then(
          response => {
            //this.desserts = response.body;
            this.status.loading = false;
            this.resolve(response.body);
          },
          response => {
            this.status = tool.responseToStatus(response);
            this.resolve(false);
          }
        );
      },

      ItemAktar(kaynak, hedef, item) {
        var n = kaynak.indexOf(item);

        var temp = {
          text: item.text,
          value: item.value,
        };

        hedef.push(temp);
        kaynak.splice(n, 1);

      },

      array_move(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);

      },

      YukariTasi(kaynak, item) {
        var n = kaynak.indexOf(item);

        this.array_move(kaynak, n, n - 1);

      },

      AsagiTasi(kaynak, item) {
        var n = kaynak.indexOf(item);
        this.array_move(kaynak, n, n + 1);
      },


      DizaynEkle() {
        tool.api_post(this, "RaporSablon/GetReportBroDesignInsert", {
            id: 0,
            ad: this.dizaynAdi,
            reportBroGrupAdi: this.GetDizaynGrupAdi,
            objectName: this.GetObjectName
          })
          .then(
            response => {
              this.items.push(response.body);
              this.item = response.body;
              this.dialogEkle = false;
            },
            response => {
              this.items = [];
              this.dialogEkle = false;
            }
          );
      },
      DizaynUpdate() {
        tool
          .api_post(this, "RaporSablon/GetReportBroDesignUpdate", {
            id: this.item.id,
            reportBroGrupid: this.item.reportBroGrupId,
            ad: this.item.ad,
            design: this.dizaynParametre
          })
          .then(
            response => {
              this.dialogEdit = false;
            },
            response => {
              this.dialogEdit = false;
            }
          );
      },
      DizaynDelete() {
        this.$refs.confirm
          .open("Kayıt Sil", this.$t('Delete-the-records'), {
            color: "red",
            message: this.$t('approve-record-deletion')
          })
          .then(confirm => {
            if (confirm == true) {
              this.sil();
            }
          });
      },
      sil() {
        tool
          .api_post(this, "RaporSablon/GetReportBroDesignDelete", {
            id: this.item.id,
            reportBroGrupid: this.item.reportBroGrupId,
            ad: this.item.ad,
            design: this.dizaynParametre
          })
          .then(
            response => {
              this.sablonGetir();
            },
            response => {}
          );
      },

      DesignShow() {
        this.Guid = "";
        this.status.loading = true;

        tool
          .api_post(this, "RaporSablon/TableDesignRead", {
            value: this.item.id,
          })
          .then(
            response => {

              var temp = JSON.parse(response.body);
              this.dizaynData2 = [];
              this.dizaynData = [];

              var i;
              for (i = 0; i < temp.length; i++) {
                if (temp[i].selected) {
                  this.dizaynData2.push(temp[i]);
                } else {
                  this.dizaynData.push(temp[i]);
                }
              }

              this.dizayndialog = true;
              this.status.loading = false;

            },
            response => {
              this.status = tool.responseToStatus(response);
            }
          );

      },

      DizaynKaydet() {

        this.status.loading = true;
        var d = [];
        var i;
        for (i = 0; i < this.dizaynData2.length; i++) {
          var item = {
            text: this.dizaynData2[i].text,
            value: this.dizaynData2[i].value,
            selected: true
          }
          d.push(item);
        }
        for (i = 0; i < this.dizaynData.length; i++) {
          var item = {
            text: this.dizaynData[i].text,
            value: this.dizaynData[i].value,
            selected: false
          }
          d.push(item);
        }

        var djosn = JSON.stringify(d);

        tool.api_post(this, "RaporSablon/TableDesignSave", {
            id: this.item.id,
            design: djosn
          })
          .then(
            response => {
              this.sablonGetir();
              this.dizayndialog = false;
              this.status.loading = false;
            },
            response => {
              this.status = tool.responseToStatus(response);
            }
          );
      },

      sablonGetir() {
        tool.api_post(this, "RaporSablon/GetReportBroDesignGrupAll", {
            id: 0,
            ad: this.GetDizaynGrupAdi,
            objectName: this.GetObjectName
          })
          .then(
            response => {
              this.items = response.body;

              if (this.items.length > 0) {
                this.item = this.items[0];
              } else {
                this.item = null;
              }

              this.ilkYukleme = false;
            },
            response => {
              this.items = [];
            }
          );
      },
      sablonGetirout(prm) {


        tool.api_post(this, "RaporSablon/GetReportBroDesignGrupAll", {
            id: prm.id,
            ad: prm.ad,
            objectName: prm.objectName
          })
          .then(
            response => {
              this.items = response.body;

              if (this.items.length > 0) {
                this.item = this.items[0];
              } else {
                this.item = null;
              }

              this.ilkYukleme = false;
            },
            response => {
              this.items = [];
            }
          );
      }


    }
  };
</script>